import React, { useEffect, useRef } from 'react';
import AdvisoryBoardCarousel from '../../component/common/advisory'
import MediaCarousel from '../../component/common/media'
import FooterHero from '../../component/common/CTA'
import { FaArrowRightLong, FaArrowRight, FaCheck } from "react-icons/fa6";
import gsap from "gsap";
import { Helmet } from 'react-helmet';
import Banner from '../../component/common/Banner';
import { ArrowRightCircleIcon } from 'lucide-react';
import { CgClose } from 'react-icons/cg';
import WhoWeAreSection from '../../component/aboutUs/whoWeAre';

const boardMembers = [
    {
        img: "img/advisory/ashish.png",
        name: "Ashish Mittal",
        position: "Founder & Chief Mentor",
        link: "https://www.linkedin.com/in/mittalashish/",
    },
    {
        img: "img/advisory/vivek.jpg",
        name: "Vivek Srivastava",
        position: "HealthTech Advisor",
        link: "https://www.linkedin.com/in/vivek-srivastava-/",
    },
    {
        img: "img/advisory/prashant.jpg",
        name: "Prashant Lohia",
        position: "RetailTech Advisor",
        link: "https://www.linkedin.com/in/ginesys/",
    },
    {
        img: "img/advisory/gagan.jpg",
        name: "Gagan Jain",
        position: "SaaSTech Advisor",
        link: "https://www.linkedin.com/in/gaganmsjain/",
    },
    {
        img: "img/advisory/vikas.jpg",
        name: "Vikas Chowdhary",
        position: "Fintech Advisor",
        link: "https://www.linkedin.com/in/vikaschaudhary-6equj5/",
    },
    {
        img: "img/advisory/venu.jpg",
        name: "Dr. V Gopal",
        position: "Edtech Advisor",
        link: "https://www.linkedin.com/in/dr-v-gopal-5a6082a/",
    },
];

const mediaData = [
    {
        title: "Student housing Startup Your-space raises Angel Funding",
        date: "January 2025",
        link: "https://www.vccircle.com/exclusive-student-housing-startup-your-space-raises-angel-funding",
    },
    {
        title: "TurningIdeas Venture to help startups with early investments",
        date: "February 2025",
        link: "https://economictimes.indiatimes.com/small-biz/money/turningideas-venture-to-help-startups-with-early-investments/articleshow/52863561.cms",
    },
    {
        title: "42 per cent of Indian Startups Plan to Go Global",
        date: "January 2025",
        link: "https://www.business-standard.com/content/press-releases-ani/42-per-cent-of-indian-startups-plan-to-go-global-in-2022-turningideas-survey-121121601096_1.html",
    },
];

const BANNER_CONTENT = [{ heading : 'About Us' , subHeading : 'Built by Founders, for Founders' , description : 'We are a venture studio that partners with startup teams to build, validate, and scale innovative ideas in India and Asia.' , url : '#know-more' , target : '_self' , linkText: 'Know More'}]

const AboutPage = () => {
    const offerSectionRef = useRef(null);
    const offerHeadingRef = useRef(null);
    const offerCardRefs = useRef([]);
    const offerAnimationTriggered = useRef(false);


    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !offerAnimationTriggered.current) {
                        offerAnimationTriggered.current = true;
                        animateOfferSection();
                        if (offerSectionRef.current) {
                            observer.unobserve(offerSectionRef.current);
                        }
                    }
                });
            },
            {
                threshold: 0.2,
            }
        );

        const currentRef = offerSectionRef.current; // Capture the ref value

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const animateOfferSection = () => {
        const heading = offerHeadingRef.current;
        const cards = offerCardRefs.current;

        const tl = gsap.timeline({ defaults: { duration: 0.8, ease: "power2.out" } });

        tl.fromTo(heading, {
            yPercent: -20,
            opacity: 0,
        }, {
            yPercent: 0,
            opacity: 1,
        });

        tl.fromTo(
            cards,
            {
                yPercent: 20,
                opacity: 0,
            },
            {
                yPercent: 0,
                opacity: 1,
                stagger: 0.15,
            },
            "-=0.5"
        );
    };


    return (
        <div>
            <Helmet>
                <title>About TurningIdeas – Startup Studio & Venture Partner</title>
                <meta name="description" content="Meet the team behind TurningIdeas – a venture studio supporting early-stage and global startups to scale in India through GTM, funding, and innovation." />
                <meta name="keywords" content="about startup studio India, TurningIdeas team, startup mentors India, co-building startups" />
            </Helmet>

            <Banner content={BANNER_CONTENT} img='img/Banner/AboutUs.png' />

            <WhoWeAreSection />


            {/* What We Offer Section */}
            <section ref={offerSectionRef} className="py-6 md:py-12 container max-w-7xl mx-auto px-6 md:px-12 my-[100px]">
                <h2 ref={offerHeadingRef} className="font-[600] text-[40px] leading-[40px] -tracking-[1.2px] md:mb-10 mb-6 text-center text-black">Our Offer</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div ref={(el) => (offerCardRefs.current[0] = el)} className="bg-orange-600 text-white md:p-20 p-8 rounded-lg max-md:h-96 h-full text-left flex flex-col max-md:justify-center relative overflow-hidden"> {/* Added flex flex-col justify-center */}
                        <h3 className="text-3xl sm:text-4xl font-medium mb-6">Co-build & Validate</h3>
                        <p className='font-medium text-lg sm:text-xl'>From idea to MVP — we help you build fast, validate real users, and iterate rapidly.</p>
                        <div className='absolute right-0 top-0 w-10 h-full bg-black opacity-[0.3]'>
                            <div className='relative w-full h-full flex items-center'>
                                <div className='w-10 h-10 rounded-full absolute -left-4 bg-black'></div>
                            </div>
                        </div>
                    </div>

                    <div ref={(el) => (offerCardRefs.current[1] = el)} className="overflow-hidden relative bg-[#1939a6] text-white md:p-20 p-8 rounded-lg max-md:h-96 h-full text-left flex flex-col max-md:justify-center"> {/* Added flex flex-col */}
                        <h3 className="text-3xl sm:text-4xl font-medium mb-6">Go-To-Market (GTM) & Sales Execution</h3>
                        <p className='font-medium text-lg sm:text-xl'>Launch with precision. We craft your funnels, run early campaigns, and close first paying customers.</p>
                        <div className='absolute right-0 top-0 w-10 h-full bg-black opacity-[0.3]'>
                            <div className='relative w-full h-full flex items-center'>
                                <div className='w-10 h-10 rounded-full absolute -left-4 bg-black'></div>
                            </div>
                        </div>
                    </div>

                    <div ref={(el) => (offerCardRefs.current[2] = el)} className="overflow-hidden relative bg-[#1939a6] text-white md:p-20 p-8 rounded-lg max-md:h-96 h-full text-left flex flex-col max-md:justify-center"> {/* Added flex flex-col */}
                        <h3 className="text-3xl sm:text-4xl font-medium mb-6">Global Market Entry Support</h3>
                        <p className='font-medium text-lg sm:text-xl'>Enter India with confidence — we handle localization, pricing, compliance, and GTM on-ground.</p>
                        <div className='absolute right-0 top-0 w-10 h-full bg-black opacity-[0.3]'>
                            <div className='relative w-full h-full flex items-center'>
                                <div className='w-10 h-10 rounded-full absolute -left-4 bg-black'></div>
                            </div>
                        </div>
                    </div>

                    <div ref={(el) => (offerCardRefs.current[3] = el)} className="overflow-hidden relative bg-orange-600 text-white md:p-20 p-8 rounded-lg max-md:h-96 h-full text-left flex flex-col max-md:justify-center"> {/* Added flex flex-col */}
                        <h3 className="text-3xl sm:text-4xl font-medium mb-6">Enterprise Innovation</h3>
                        <p className='font-medium text-lg sm:text-xl'>Bridging the gap between Corporations and Startups for Innovation.</p>
                        <div className='absolute right-0 top-0 w-10 h-full bg-black opacity-[0.3]'>
                            <div className='relative w-full h-full flex items-center'>
                                <div className='w-10 h-10 rounded-full absolute -left-4 bg-black'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='min-[670px]:hidden container max-w-7xl mx-auto px-6 md:px-12 my-[100px]'>
                <h2 className='text-center text-black font-[600] text-[34px] sm:text-[40px] leading-[45px] sm:leading-[50px] -tracking-[1.2px]'>What Type of Founders We Work With</h2>
                <div className='bg-[#C8F2FF] grid grid-cols-[max-content_max-content] overflow-x-auto rounded-[15px] p-6 mt-12'>
                    <article>
                        <h4 className='flex items-center gap-x-3 border-b-[4px] border-[#82E2FF] items-center px-3 py-7'>
                            <span className='p-1 rounded-full bg-green-600'><FaCheck className='text-white text-[16px]' /></span>
                            <span className='font-[600] text-black text-[22px] leading-[20px]'>We love founders </span>
                        </h4>
                        <ol className='flex flex-col gap-y-3'>
                            <li className='px-3 py-8 border-b-[4px] border-[#82E2FF] text-[#000000] font-[500] text-[18px]'>Have deep insights into a problem</li>
                            <li className='px-3 py-8 border-b-[4px] border-[#82E2FF] text-[#000000] font-[500] text-[18px]'>Need execution partners</li>
                            <li className='px-3 py-8 text-[#000000] font-[500] text-[18px]'>Are building for India or Asia</li>
                        </ol>
                    </article>
                    <article>
                        <h4 className='flex items-center gap-x-3 border-b-[4px] border-[#82E2FF] items-center pr-3 pl-10 py-7'>
                            <span className='p-1 rounded-full bg-red-600'><CgClose className='text-white text-[16px]' /></span>
                            <span className='font-[600] text-black text-[22px] leading-[20px]'>We are not a fit if</span>
                        </h4>
                        <ol className='flex flex-col gap-y-3'>
                            <li className='pl-10 pr-3 py-8 border-b-[4px] border-[#82E2FF] text-[#000000] font-[500] text-[18px]'>Just want funding without commitment</li>
                            <li className='pl-10 pr-3 py-8 border-b-[4px] border-[#82E2FF] text-[#000000] font-[500] text-[18px]'>Want to outsource everything</li>
                            <li className='pl-10 pr-3 py-8 text-[#000000] font-[500] text-[18px]'>Don’t want to scale fast</li>
                        </ol>
                    </article>
                </div>
            </section>

            <section className='max-[670px]:hidden container max-w-7xl mx-auto px-6 md:px-12 my-[100px]'>
                <h2 className='text-center text-black font-[600] text-[40px] leading-[40px] -tracking-[1.2px]'>What Type of Founders We Work With</h2>
                <div className='bg-[#C8F2FF] rounded-[15px] p-6 mt-12'>
                    <article className='w-full'>
                        <div className='grid grid-cols-2 gap-x-8 border-b-[4px] border-[#82E2FF] py-7 px-9'>
                            <h4 className='grid grid-cols-[max-content_1fr] gap-x-3 items-center'>
                                <span className='p-1 rounded-full bg-green-600'><FaCheck className='text-white text-[16px]' /></span>
                                <span className='font-[600] text-black text-[22px] leading-[20px]'>We love founders </span>
                            </h4>
                            <h4 className='grid grid-cols-[max-content_1fr] gap-x-3 items-center pr-14 min-[1000px]:pr-24'>
                                <span className='p-1 rounded-full bg-red-600'><CgClose className='text-white text-[16px]' /></span>
                                <span className='font-[600] text-black text-[22px] leading-[20px]'>We are not a fit if</span>
                            </h4>
                        </div>
                        <ol>
                            <li className='grid grid-cols-2 gap-x-8 border-b-[4px] border-[#82E2FF] py-8 px-9'>
                                <span className='text-[#000000] font-[500] text-[18px]'>Have deep insights into a problem</span>
                                <span className='text-[#000000] font-[500] text-[18px]'>Just want funding without commitment</span>
                            </li>
                            <li className='grid grid-cols-2 gap-x-8 border-b-[4px] border-[#82E2FF] py-8 px-9'>
                                <span className='text-[#000000] font-[500] text-[18px]'>Need execution partners</span>
                                <span className='text-[#000000] font-[500] text-[18px]'>Want to outsource everything</span>
                            </li>
                            <li className='grid grid-cols-2 gap-x-8 py-8 px-9'>
                                <span className='text-[#000000] font-[500] text-[18px]'>Are building for India or Asia</span>
                                <span className='text-[#000000] font-[500] text-[18px]'>Don’t want to scale fast</span>
                            </li>
                        </ol>
                    </article>
                </div>
            </section>

            <section className="container max-w-7xl mx-auto px-6 md:px-12">
                <AdvisoryBoardCarousel members={boardMembers} />
            </section>

            <section className="mx-auto px-6 md:px-12 py-6 md:py-12 bg-black mt-[100px]">
                <MediaCarousel mediaItems={mediaData} />
            </section>

            <FooterHero
                heading="Want a Partner to Co-Build"
                paragraph="Whether you're a startup, investor, or enterprise, we help you scale, innovate, and succeed."
                buttonText="Contact Us Today!"
            />
        </div>
    );
};

export default AboutPage;